import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, isRef as _isRef } from "vue"

import {
    PickAndPackParcelShopCheckOutDeliveryOption,
} from '@/storecontext/shared/api/server-apis';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import CheckoutRadioButton from '@/shared/checkout/ui/CheckoutRadioButton.vue';
import CheckoutPickAndPackParcelShopInfo from '@/storecontext/checkout/ui/deliverables/pick-and-pack/CheckoutPickAndPackParcelShopInfo.vue';
import { useField } from 'vee-validate';
import { useCheckout } from '@/storecontext/checkout/useCheckout';
import useBooleanToggle from '@/shared/useBooleanToggle';
import CheckoutPickAndPackParcelShopDialog from '@/storecontext/checkout/ui/deliverables/pick-and-pack/CheckoutPickAndPackParcelShopDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPickAndPackParcelShopOption',
  props: {
    deliverableId: null,
    deliveryOption: null,
    showLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    deliverableId?: number;
    deliveryOption: PickAndPackParcelShopCheckOutDeliveryOption;
    showLoading?: boolean;
}



const labels = useBlockLabels();

const { isToggled, toggle } = useBooleanToggle();

const { setPickAndPackToParcelShopDelivery, getNearestParcelShopsForDelivery } = useCheckout();

const init = async() => {
    if (props.deliveryOption.isSelected && !props.deliveryOption.parcelShop && props.deliverableId) {
        const parcelShops = await getNearestParcelShopsForDelivery(props.deliverableId, 1);
        const parcelShop = parcelShops[0];
        if (parcelShop) {
            setPickAndPackToParcelShopDelivery(parcelShop);
        }
    }
};
init();

const { value } = useField('pickAndPack');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CheckoutRadioButton, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
    value: __props.deliveryOption.deliveryType,
    label: _unref(labels).pickAndPackParcelShopTitle + ' - ' + __props.deliveryOption.price.amount,
    "is-selected": __props.deliveryOption.isSelected,
    name: "pickAndPack"
  }, {
    default: _withCtx(() => [
      (_unref(value) === __props.deliveryOption.deliveryType)
        ? (_openBlock(), _createBlock(CheckoutPickAndPackParcelShopInfo, {
            key: 0,
            class: "mt-x3",
            "show-loading": __props.showLoading,
            "parcel-shop": __props.deliveryOption.parcelShop
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "c-button c-button--outline mt-x2",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(toggle) && _unref(toggle)(...args)), ["prevent"]))
              }, _toDisplayString(_unref(labels).pickAndPackParcelShopOpenDialogButton), 1),
              (_unref(isToggled))
                ? (_openBlock(), _createBlock(CheckoutPickAndPackParcelShopDialog, {
                    key: 0,
                    "is-open": _unref(isToggled),
                    "deliverable-id": __props.deliverableId,
                    "selected-parcel-shop": __props.deliveryOption.parcelShop,
                    onClose: _unref(toggle)
                  }, null, 8, ["is-open", "deliverable-id", "selected-parcel-shop", "onClose"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["show-loading", "parcel-shop"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "value", "label", "is-selected"]))
}
}

})